// extracted by extract-css-chunks-webpack-plugin
module.exports = {"news_box":"news_box-1xRSKuCA clearfix","box_r":"box_r-2E-dZCXl","d_box":"d_box-1rN-PkYE"};